import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, Tooltip } from '@salesforce/design-system-react';

import './PredictedWinnerBadge.scss';

class PredictedWinnerBadge extends Component {
  render() {
    return (
      <Tooltip
        align="right"
        content={
          <FormattedMessage
            id={
              'components.experiment.performance.results.predictedWinnerTooltip'
            }
          />
        }
      >
        <Button
          className="predicted-winner-badge"
          label={
            <FormattedMessage
              id={'components.experiment.performance.results.predictedWinner'}
            />
          }
          iconCategory="utility"
          iconName="einstein"
          iconSize="small"
        />
      </Tooltip>
    );
  }
}

export default injectIntl(PredictedWinnerBadge);
